<akeela-auth-recovery-password [config]="config" (response)="getResponse($event)">

</akeela-auth-recovery-password>